import { Field } from '@base-ui/react/field';
import classes from "./YuJaTextArea.module.css"
import {ReactComponent as ERROR} from "../../images/cross_cricle_red.svg"
import React from "react";

export default function YuJaTextArea({
                                         value,
                                         maxLength=65,
                                         placeholder="",
                                         onChange,
                                         isValid=true,
                                         disabled=false,
                                         errorMsg="",
                                         inputStyle,
                                         ...props
}) {
    return(
        <Field.Root className={classes.Field} disabled={disabled} invalid={!isValid}>
            <div className={classes.inputWrapper} style={{...inputStyle}}>
                <Field.Control
                    render={<textarea className={classes.Textarea} />}
                    value={value ?? ""}
                    onValueChange={onChange}
                    maxLength={maxLength}
                    placeholder={placeholder}
                    {...props}
                />
                {/* This sits ON TOP of the textarea in the corner */}
                <span className={classes.Counter}>
                  {value.length}/{maxLength}
                </span>
            </div>
            {!!errorMsg &&
                <Field.Error className={classes.Error} match={!isValid}>
                    <ERROR style={{flexShrink: 0}}/> <span>{errorMsg}</span>
                </Field.Error>
            }
        </Field.Root>
    );
}